export default __webpack_public_path__ + "static/media/HDFC3.Ologo.8b2bff75.jpg";